/*
Copyright (c) 2021,Company copyright header
*/

function maverickPortalApiEndPoint() {
  const self = {};

  self.login = {
    url: '/webLogin',
    methodType: 'post'
  };
  self.resetPassword = {
    url: '/passwordReset',
    methodType: 'post'
  };
  self.addTag = {
    url: '/addTag',
    methodType: 'post'
  };
  self.getTags = {
    url: '/getProjectTags',
    methodType: 'get'
  };
  self.createProject = {
    url: '/createProject',
    methodType: 'post'
  };
  self.createWebLinkAccount = {
    url: '/createWebLinkAccount',
    methodType: 'post'
  };
   self.createWebLinkAccount2 = {
    url: '/createWebLinkAccount2',
    methodType: 'post'
  };
  self.CheckFileInS3 ={
    url:'/CheckFileInS3',
    methodType: 'post'
  }
  self.webLinkLoginOTP = {
    url: '/webLinkLoginOTP',
    methodType: 'post'
  };
  self.automatedWeblinkAnswer = {
    url: '/automatedWeblinkAnswer',
    methodType: 'post'
  };
  self.uploadWebLinkQuestionImage = {
    url: '/uploadWebLinkQuestionImage',
    methodType: 'post'
  };
  self.uploadQuestionMP3 = {
    url: '/uploadQuestionMP3',
    methodType: 'post'
  };
  self.updateRespondentTaskStatus = {
    url: '/updateRespondentTaskStatus',
    methodType: 'post'
  };
  self.uploadWebLinkQuestionMP4 = {
    url: '/uploadWebLinkQuestionMP4',
    methodType: 'post'
  };
  self.getWeblinkQuestions = {
    url: '/getWeblinkQuestions',
    methodType: 'post'
  };
  self.getWeblinkRespondentDetails = {
    url: '/getWeblinkRespondentDetails',
    methodType: 'get'
  };
  self.getWeblinkScreenerQuestions = {
    url: '/getWeblinkScreenerQuestions',
    methodType: 'post'
  };
  self.getWeblinkDesignQuestions = {
    url: '/getWeblinkDesignQuestions',
    methodType: 'post'
  };
  self.editProfile = {
    url: '/editProfile',
    methodType: 'post'
  };
  self.preProfileData = {
    url: '/preProfileData',
    methodType: 'post'
  };
  self.verifyWeblinkOTP = {
    url: '/verifyWeblinkOTP',
    methodType: 'post'
  };
  self.weblinkValidation = {
    url: '/weblinkValidation',
    methodType: 'post'
  };
  self.editProject = {
    url: '/editProjectDetails',
    methodType: 'post'
  };
  self.fetchScreenerAnswers = {
    url: '/fetchScreenerAnswers',
    methodType: 'get'
  };
  self.fetchFormAnswers = {
    url: '/fetchFormAnswers',
    methodType: 'get'
  };
  self.deleteMedia = {
    url: '/deleteMedia',
    methodType: 'post'
  };
  self.deleteReferral = {
    url: '/deleteReferral',
    methodType: 'post'
  };

  self.preProject = {
    url: '/preProjectSetupData',
    methodType: 'post'
  };
  self.requestUpdateTaskStatus = {
    url: '/updateTaskStatus',
    methodType: 'post'
  };
  self.ProjectSetupData = {
    url: '/preCreateProject',
    methodType: 'get'
  };
  self.RecruitsGroupData = {
    url: '/filterRecruitsGroupwise',
    methodType: 'post'
  };
  self.GetProjectGroup = {
    url: '/GetProjectGroup',
    methodType: 'get'
  };

  self.viewDesignQue_ans = {
    url: '/viewDesignQue_ans',
    methodType: 'get'
  };

  self.getDesignMp4 = {
    url: '/getDesignMp4',
    methodType: 'get'
  };

  self.sendInvitation = {
    url: '/sendInvitation',
    methodType: 'post'
  };
  self.uploadQuestionMP3 = {
    url: '/uploadQuestionMP3',
    methodType: 'post'
  };
  self.generateProjectQR = {
    url: '/generateProjectQR',
    methodType: 'post'
  };
  self.uploadWebLinkQuestionMP4 = {
    url: '/uploadWebLinkQuestionMP4',
    methodType: 'post'
  };
  self.uploadWebLinkQuestionImage = {
    url: '/uploadWebLinkQuestionImage',
    methodType: 'post'
  };
  self.updateRespondentTaskStatus = {
    url: '/updateRespondentTaskStatus',
    methodType: 'post'
  };
  self.addVideoTag = {
    url: '/addVideoTag',
    methodType: 'post'
  };
  self.addVideoNote = {
    url: '/addVideoNote',
    methodType: 'post'
  };
  self.getVideoTag = {
    url: '/getVideoTag',
    methodType: 'get'
  };
  self.deleteCustomtag = {
    url: '/deleteAnalysisCustomTags',
    methodType: 'post'
  };
  self.editCustomTagName = {
    url: '/editCustomTagName',
    methodType: 'post'
  };
  self.deleteCohort = {
    url: '/cohortDeletion',
    methodType: 'post'
  };
  self.getVideoNote = {
    url: '/getVideoNote',
    methodType: 'get'
  };
  self.RecruitScreener = {
    url: '/getScreenerResponses',
    methodType: 'get'
  };
  self.rejectInvitation = {
    url: '/rejectRespondent',
    methodType: 'post'
  };
  self.getInviteeData = {
    url: '/getinviteesData',
    methodType: 'post'
  };
  self.confirmAndAssignProjectGroup = {
    url: '/confirmAndAssignProjectGroup',
    methodType: 'post'
  };
  self.reassignProjectGroups = {
    url: '/reassignProjectGroups',
    methodType: 'post'
  };
  self.confirmRespondent = {
    url: '/confirmRespondent',
    methodType: 'post'
  };
  self.deleteProjectImage = {
    url: '/deleteProjectImage',
    methodType: 'post'
  };
  self.getProjectTask = {
    url: '/getProjectTaskQuestions',
    methodType: 'get'
  };
  self.getFieldTaskCompleteCount = {
    url: '/getFieldTaskCompleteCount',
    methodType: 'get'
  };
  self.getTaskCompletionStatus = {
    url: '/getTaskCompletionStatus',
    methodType: 'get'
  };
  self.getVideoTaskCompletionStatus = {
    url: '/getVideoTaskCompletionStatus',
    methodType: 'get'
  };
  self.getTaskResponses = {
    url: '/getTaskResponses',
    methodType: 'get'
  };
  self.addProjectTask = {
    url: '/addProjectTask',
    methodType: 'post'
  };
  self.deleteProjectTask = {
    url: '/deleteProjectTask',
    methodType: 'post'
  };
  self.updateProjectTask = {
    url: '/editProjectTask',
    methodType: 'post'
  };
  self.createProjectLead = {
    url: '/createProjectLead',
    methodType: 'post'
  };
  self.addProjectResercher = {
    url: '/addProjectResercher',
    methodType: 'post'
  };
  self.addProjectObserver = {
    url: '/addProjectObserver',
    methodType: 'post'
  };
  self.getCriteriaAndBudget = {
    url: '/getCriteriaAndBudget',
    methodType: 'get'
  };
  self.updateProjectStage = {
    url: '/updateProjectStage',
    methodType: 'post'
  };
  self.getResolution = {
    url: '/getResolution',
    methodType: 'post'
  };

  self.getParticipant = {
    url: '/fetchResearcherName',
    methodType: 'post'
  };
  self.removeVideoCall = {
    url: '/removeVideoCall',
    methodType: 'post'
  };

  self.GetEditSection = {
    url: '/editSection',
    methodType: 'post'
  };
  self.GetAddSection = {
    url: '/addSection',
    methodType: 'post'
  };

  self.GetDragQuestion = {
    url: '/dragAndDropQuestions',
    methodType: 'post'
  };

  self.GetDragQuestionAcrossSections = {
    url: '/interPaperSectionDragDrop',
    methodType: 'post'
  };

  self.GetDragSection = {
    url: '/dragAndDropSections',
    methodType: 'post'
  };

  self.CountNoParticipant = {
    url: '/noOfParticipant',
    methodType: 'post'
  };

  self.VideoRecording = {
    url: `https://api.agora.io/v1/apps/${process.env.REACT_APP_AGORA_AGORA_APP_ID}/cloud_recording/acquire`,
    methodType: 'post'
  };

  self.VideoRecordingResource = {
    url: `https://api.agora.io/v1/apps/${process.env.REACT_APP_AGORA_AGORA_APP_ID}/cloud_recording/resourceid`,
    methodType: 'post'
  };

  self.QueryVideoRecording = {
    url: `https://api.agora.io/v1/apps/${process.env.REACT_APP_AGORA_AGORA_APP_ID}/cloud_recording/resourceid`,
    methodType: 'get'
  };

  self.updateLayoutVideoRecording = {
    url: `https://api.agora.io/v1/apps/${process.env.REACT_APP_AGORA_AGORA_APP_ID}/cloud_recording/resourceid`,
    methodType: 'post'
  };

  self.stopVideoRecording = {
    url: `https://api.agora.io/v1/apps/${process.env.REACT_APP_AGORA_AGORA_APP_ID}/cloud_recording/resourceid`,
    methodType: 'post'
  };

  self.Resume = {
    url: '/getProjectResumeData',
    methodType: 'get'
  };

  self.Schedulecall = {
    url: '/getVideoTaskCompletionStatus',
    methodType: 'get'
  };

  self.updateDuration = {
    url: '/updateDuration',
    methodType: 'post'
  };
  self.getVideoTask = {
    url: '/getVideoTaskQuestionPaper',
    methodType: 'get'
  };
  self.editTaskQuestion = {
    url: '/editQuestion',
    methodType: 'post'
  };
  self.updateProjectScreener = {
    url: '/updateProjectScreener',
    methodType: 'post'
  };
  self.addScreenerValidationQuestion = {
    url: '/addScreenerValidationQuestion',
    methodType: 'post'
  };
  self.editScreenerAnswer = {
    url: '/editScreenerAnswer',
    methodType: 'post'
  };
  self.editAutomatedScreener = {
    url: '/editAutomatedScreener',
    methodType: 'post'
  };
  self.addQuestionTags = {
    url: '/addQuestionTags',
    methodType: 'post'
  };
  self.deleteQuestionTag = {
    url: '/deleteProjectTag',
    methodType: 'post'
  };
  self.editVideoQuestion = {
    url: '/editInstruction',
    methodType: 'post'
  };
  self.deleteQuestion = {
    url: '/deleteQuestion',
    methodType: 'post'
  };
  self.deleteSection = {
    url: '/deleteSection',
    methodType: 'post'
  };
  self.addQuestion = {
    url: '/addQuestion',
    methodType: 'post'
  };
  self.showScreenerFilterOnAnalysis = {
    url: '/showScreenerFilterOnAnalysis',
    methodType: 'post'
  };
  self.getScheduleDate = {
    url: '/getScheduleDatesData',
    methodType: 'get'
  };
  self.addScheduleDate = {
    url: '/addScheduleDates',
    methodType: 'post'
  };
  self.editScheduleDate = {
    url: '/editScheduleDate',
    methodType: 'post'
  };
  self.deleteScheduleDate = {
    url: '/deleteScheduleDate',
    methodType: 'post'
  };
  self.addProjectGroup = {
    url: '/addProjectGroup',
    methodType: 'post'
  };
  self.editProjectGroup = {
    url: '/editProjectGroup',
    methodType: 'post'
  };
  self.deleteProjectGroup = {
    url: '/deleteProjectGroup',
    methodType: 'post'
  };
  self.createBudget = {
    url: '/createBudget',
    methodType: 'post'
  };
  self.deleteBudget = {
    url: '/deleteBudget',
    methodType: 'post'
  };
  self.assignSampleAndBudget = {
    url: '/assignSampleAndBudget',
    methodType: 'post'
  };
  self.deassignSampleAndBudget = {
    url: '/deassignSampleAndBudget',
    methodType: 'post'
  };
  self.getPublishData = {
    url: '/getPublishData',
    methodType: 'get'
  };

  self.webDashboard = {
    url: '/webDashboard',
    methodType: 'post'
  };

  self.calenderData = {
    url: '/getCalendarData',
    methodType: 'post'
  };

  self.getVideo = {
    url: '/getRecordTaskVideo/18/6',
    methodType: 'get'
  };

  self.videoTrim = {
    url: `https://${process.env.REACT_APP_TRIMMING_BACKEND_URL}/api/videoTrimming`,
    methodType: 'post'
  };

  self.getAllTrimClips = {
    url: '/getAllTrimClips',
    methodType: 'post'
  };
  self.getFieldOverview = {
    url: '/fieldOverview',
    methodType: 'get'
  };
  self.getCaptureGuide = {
    url: '/getCaptureGuide',
    methodType: 'get'
  };
  self.addNewNote = {
    url: '/addNewNote',
    methodType: 'post'
  };
  self.deleteNote = {
    url: '/deleteVideoNote',
    methodType: 'post'
  };

  self.getRecordTaskVideo = {
    url: '/getRecordTaskVideo',
    methodType: 'get'
  };

  self.addTimestampAgainstVideoQuestions = {
    url: '/addTimestampAgainstVideoQuestions',
    methodType: 'post'
  };

  self.getPreEditorData = {
    url: '/preEditorSelector',
    methodType: 'get'
  };

  self.editEditorTranscriptData = {
    url: '/editEditorTranscript',
    methodType: 'post'
  };

  self.startInterview = {
    url: '/startInterview',
    methodType: 'post'
  };

  self.sendParticipanstListonStart = {
    url: '/joinResearcherName',
    methodType: 'post'
  };

  self.endInterview = {
    url: '/endInterview',
    methodType: 'post'
  };

  self.sendParticipanstListonEnd = {
    url: '/deleteResearcherName',
    methodType: 'post'
  };

  self.deleteVideoNote = {
    url: '/deleteVideoNote',
    methodType: 'post'
  };

  self.deleteVideoTag = {
    url: '/deleteVideoTag',
    methodType: 'post'
  };

  self.deleteFormTag = {
    url: '/deleteFormTag',
    methodType: 'post'
  };

  self.editVideoNote = {
    url: '/editVideoNote',
    methodType: 'post'
  };

  self.editButtonName = {
    url: '/editButtonName',
    methodType: 'post'
  };

  self.getProfileData = {
    url: '/getProfileData',
    methodType: 'get'
  };

  self.editProfileData = {
    url: '/editProfileData',
    methodType: 'post'
  };

  self.logout = {
    url: '/webLogout',
    methodType: 'post'
  };

  self.getAnalysisData = {
    url: '/getProjectAnalysisData',
    methodType: 'post'
  };

  self.getScreenerAnalysisData = {
    url: '/getProjectScreenerAnalysisData',
    methodType: 'post'
  };

  self.getAnalysisCsv = {
    url: '/analysisDownloadCsv',
    methodType: 'post'
  };
  self.getAnalysisCsvWithCode = {
    url: '/analysisCsvWithCode',
    methodType: 'post'
  };
  self.publishProject = {
    url: '/publishProject',
    methodType: 'post'
  };

  self.getGraphData = {
    url: '/getGraphData',
    methodType: 'post'
  };

  self.deleteClip = {
    url: '/deleteClip',
    methodType: 'post'
  };

  self.changePasswordWeb = {
    url: '/changePasswordWeb',
    methodType: 'post'
  };

  self.getWordCloudAnswer = {
    url: '/getWordCloudAnswers',
    methodType: 'post'
  };

  self.editClip = {
    url: `https://${process.env.REACT_APP_TRIMMING_BACKEND_URL}/api/editClip`,
    methodType: 'post'
  };

  self.getFilterData = {
    url: '/getFilterData',
    methodType: 'get'
  };

  self.addCohort = {
    url: '/addCohort',
    methodType: 'post'
  };

  self.VideoRecordingUserList = {
    url: `https://api.agora.io/dev/v1/channel/user/${process.env.REACT_APP_AGORA_AGORA_APP_ID}`,
    methodType: 'get'
  };

  self.getUIDDetails = {
    url: '/getUIDDetails',
    methodType: 'get'
  };

  self.stitchVideo = {
    url: `https://${process.env.REACT_APP_TRIMMING_BACKEND_URL}/api/stitchingClips`,
    methodType: 'post'
  };
  self.VideoRecordingUpdate = {
    url: `https://api.agora.io/v1/apps/${process.env.REACT_APP_AGORA_AGORA_APP_ID}/cloud_recording/resourceid`,
    methodType: 'post'
  };

  self.rescheduleSlot = {
    url: '/rescheduleSlot',
    methodType: 'post'
  };

  self.endProject = {
    url: '/endProject',
    methodType: 'post'
  };

  self.addRespondentAnswer = {
    url: '/addRespondentAnswer',
    methodType: 'post'
  };

  self.RtcTokenBuilder = {
    url: '/getAgoraToken',
    methodType: 'post'
  };

  self.deleteTeamMember = {
    url: '/deleteTeamMember',
    methodType: 'post'
  };

  self.clientDashboard = {
    url: '/clientDashboard',
    methodType: 'post'
  };

  self.editTeam = {
    url: '/editTeam',
    methodType: 'post'
  };

  self.addNewUser = {
    url: '/addNewUser',
    methodType: 'post'
  };

  self.deleteUser = {
    url: '/deleteUser',
    methodType: 'post'
  };

  self.editUser = {
    url: '/editUser',
    methodType: 'post'
  };

  self.deleteProject = {
    url: '/DeleteProject',
    methodType: 'post'
  };

  /* super Admin Api Endpoints */

  self.createAdmin = {
    url: '/CreateAdmin',
    methodType: 'post'
  };

  self.createUserInGeneralPool = {
    url: '/createUserInGeneralPool',
    methodType: 'post'
  };

  // self.editClientAdmin ={
  //   url: '/getUserdata',
  //   methodType: 'get'
  // };
  self.editClientAdmin = {
    url: '/editAdmin',
    methodType: 'post'
  };

  self.editResearcher = {
    url: '/editResearcher',
    methodType: 'post'
  };

  self.editRespondant = {
    url: '/editRespondant',
    methodType: 'post'
  };

  self.superAdminDashboard = {
    url: '/viewAdmin',
    methodType: 'get'
  };

  self.viewUserInGeneralPool = {
    url: '/viewUserInGeneralpool',
    methodType: 'get'
  };

  self.viewProjectSuperAdminDashboard = {
    url: '/viewAllProjects',
    methodType: 'get'
  };

  self.SendOtp = {
    url: '/sendOtp',
    methodType: 'post'
  };

  self.ValidateOtpWeb = {
    url: '/ValidateOtpWeb',
    methodType: 'post'
  };
  self.resetPasswordforadmin = {
    url: '/resetPasswordSendEmail',
    methodType: 'get'
  };

  self.addAgoraStopApiLogs = {
    url: '/checkAgoraResponse',
    methodType: 'post'
  };

  self.PasswordResetEmailNotificationTokenValidate = {
    url: '/validateToken',
    methodType: 'get'
  };

  // self.editSummary = {
  //   url: '/editSummary',
  //   methodType: 'post'
  // };

  self.getAnalysisClipsData = {
    url: '/GetClips',
    methodType: 'post'
  };

  self.getAnalysisClipsWithoutUrl = {
    url: '/getClipswithoutURL',
    methodType: 'post'
  };

  self.addStartApiLogsAgora = {
    url: '/StoreCallLogs',
    methodType: 'post'
  };

  self.respondentDaashboardData = {
    url: '/FieldOverviewForRespondent',
    methodType: 'get'
  };

  self.saveRtmTranscriptData = {
    url: '/storingTranscriptDataAzure',
    methodType: 'post'
  };

  self.storeTranscriptLogs = {
    url: '/StoreTranscriptLogs',
    methodType: 'post'
  };

  self.updateSidData = {
    url: '/insertSid',
    methodType: 'post'
  };

  self.storeAISummaryLogs = {
    url: '/storeAISummaryLogs',
    methodType: 'post'
  };
  self.getRtmTranscriptData = {
    url: '/getTranscriptDataAzure',
    methodType: 'post'
  };

  self.getChapterization = {
    url: `https://${process.env.REACT_APP_PYTHON_API}/get_chapterization`,
    methodType: 'get'
  };

  self.updateRtmTranscriptData = {
    url: '/editTranscript',
    methodType: 'post'
  };

  self.updateGuestData = {
    url: 'https://maverick-python.az.dev.humanifytechnologies.com/change_names',
    methodType: 'post'
  };

  self.getAnalysisSummary = {
    url: '/getAnalysisSummary',
    methodType: 'get'
  };

  self.editSummary = {
    url: '/editSummary',
    methodType: 'post'
  };

  self.checkSummary = {
    url: '/checkSummary',
    methodType: 'get'
  };

  self.generateSummary = {
    url: `https://${process.env.REACT_APP_PYTHON_API}`,
    methodType: 'get'
  };

  self.transcriptCsv = {
    url: `/getDesigntranscriptCSV`,
    methodType: 'get'
  };

  self.updateLayout = {
    url: '/updatelayoutrecording',
    methodType: 'post'
  };

  self.getQuestiontranscriptCSV = {
    url: '/getQuestiontranscriptCSV',
    methodType: 'post'
  };

  self.getCountryDetails = {
    url: '/getCountryDetails',
    methodType: 'get'
  };

  self.twilioSendOTP = {
    url: '/twilioSendOTP',
    methodType: 'post'
  };

  self.twilioCheckWebLinkOTP = {
    url: '/twilioCheckWebLinkOTP',
    methodType: 'post'
  };

   self.twilioSendOTP2 = {
    url: '/twilioSendOTP2',
    methodType: 'post'
  };

  self.twilioCheckWebLinkOTP2 = {
    url: '/twilioCheckWebLinkOTP2',
    methodType: 'post'
  };

  self.updateRegion = {
    url: '/updateRegion',
    methodType: 'post'
  };
  
  return self;
}

export default maverickPortalApiEndPoint();
